"use client";

import { Badge } from "@devhop/ui";

export type ShiftSwapRequestStatus =
  | "pending"
  | "approved"
  | "rejected"
  | "canceled";

const LABELS: Record<ShiftSwapRequestStatus, string> = {
  pending: "ລໍຖ້າອະນຸມັດ",
  approved: "ອະນຸມັດແລ້ວ",
  rejected: "ປະຕິເສດ",
  canceled: "ຍົກເລີກ",
};

export function shiftSwapRequestStatusLabel(
  status: string,
): string {
  return status in LABELS
    ? LABELS[status as ShiftSwapRequestStatus]
    : status;
}

/** ສີຕາມ PARTZYNC: ລໍຖ້າ=accent (Action Orange), ອະນຸມັດ=success, ປະຕິເສດ=destructive, ຍົກເລີກ=secondary */
function variantFor(status: string) {
  switch (status) {
    case "pending":
      return "accent" as const;
    case "approved":
      return "success" as const;
    case "rejected":
      return "destructive" as const;
    case "canceled":
      return "secondary" as const;
    default:
      return "secondary" as const;
  }
}

export function ShiftSwapRequestStatusBadge({
  status,
  className,
}: {
  status: string;
  className?: string;
}) {
  return (
    <Badge
      variant={variantFor(status)}
      className={className ?? "font-normal"}
    >
      {shiftSwapRequestStatusLabel(status)}
    </Badge>
  );
}
